import * as React from 'react';
import { DateTimeFormats, DateTimeFormatterFn, useDateTimeFormatter } from '../../hooks';
import { LocalTimeString, localTimeToDate } from '../TimeOnlyFormatter';

type TreatAsUTC = boolean;

export interface TimePeriodFormatterProps {
  startTime?: LocalTimeString | Date | null;
  endTime?: LocalTimeString | Date | null;
  id?: string;
  utc?: TreatAsUTC;
}

export const TimePeriodFormatter: React.FC<React.PropsWithChildren<TimePeriodFormatterProps>> = ({
  startTime,
  endTime,
  id,
  utc
}) => {
  const { dateTimeFormatter } = useDateTimeFormatter();
  if (!startTime && !endTime) return null;

  return (
    <span className="time-period" id={id}>
      {formatTimePeriod(dateTimeFormatter, startTime, endTime, utc)}
    </span>
  );
};

function formatTimePeriod(
  dateTimeFormatter: DateTimeFormatterFn,
  startTime?: LocalTimeString | Date | null,
  endTime?: LocalTimeString | Date | null,
  utc?: TreatAsUTC
) {
  const localStartDate = typeof startTime === 'object' ? startTime : localTimeToDate(startTime, true);
  const localEndDate = typeof endTime === 'object' ? endTime : localTimeToDate(endTime, true);

  const start = dateTimeFormatter(localStartDate, {
    format: DateTimeFormats.TIME,
    utc,
    noTimeZone: true
  });
  const end = dateTimeFormatter(localEndDate, {
    format: DateTimeFormats.TIME,
    utc,
    noTimeZone: true
  });

  return start === '-' && end === '-' ? '' : `${start ?? ''} - ${end ?? ''}`.trim();
}
